import GaIconPaths from './selection.json';
var iconSetData = GaIconPaths.icons.map(function (icon) {
  return icon.properties.name;
});
export default iconSetData;